// Generated by tools/animation/extract_secondary_motion_collision_evidence.py.
// Do not hand-edit; values come from the original Shenmue executable.

const KOK_POINTS = Object.freeze([
  Object.freeze({ controllerType: 47, localPosition: Object.freeze([0.01, 0, 0.12]), radius: 0.11 }),
  Object.freeze({ controllerType: 47, localPosition: Object.freeze([0.04, 0, 0.04]), radius: 0.08 }),
  Object.freeze({ controllerType: 47, localPosition: Object.freeze([0.01, 0, 0.08]), radius: 0.08 }),
  Object.freeze({ controllerType: 47, localPosition: Object.freeze([0.01, 0, -0.07]), radius: 0.09 }),
  Object.freeze({ controllerType: 2, localPosition: Object.freeze([0.25, 0, -0.12]), radius: 0.14 }),
  Object.freeze({ controllerType: 2, localPosition: Object.freeze([0.25, 0, 0.12]), radius: 0.14 }),
  Object.freeze({ controllerType: 2, localPosition: Object.freeze([-0.01, 0.01, 0.07]), radius: 0.11 }),
  Object.freeze({ controllerType: 2, localPosition: Object.freeze([-0.01, -0.01, -0.07]), radius: 0.11 }),
  Object.freeze({ controllerType: 7, localPosition: Object.freeze([-0.01, 0, -0.15]), radius: 0.1 }),
  Object.freeze({ controllerType: 7, localPosition: Object.freeze([0.04, 0.01, 0.05]), radius: 0.12 }),
  Object.freeze({ controllerType: 13, localPosition: Object.freeze([-0.01, 0, 0.15]), radius: 0.1 }),
  Object.freeze({ controllerType: 13, localPosition: Object.freeze([0.04, 0.01, -0.05]), radius: 0.12 }),
  Object.freeze({ controllerType: 9, localPosition: Object.freeze([0.02, 0, 0.01]), radius: 0.09 }),
  Object.freeze({ controllerType: 9, localPosition: Object.freeze([0.24, 0, 0]), radius: 0.09 }),
  Object.freeze({ controllerType: 15, localPosition: Object.freeze([0.02, 0, -0.01]), radius: 0.09 }),
  Object.freeze({ controllerType: 15, localPosition: Object.freeze([0.24, 0, 0]), radius: 0.09 }),
  Object.freeze({ controllerType: 10, localPosition: Object.freeze([0, 0, 0]), radius: 0.09 }),
  Object.freeze({ controllerType: 10, localPosition: Object.freeze([0.32, -0.02, 0]), radius: 0.1 }),
  Object.freeze({ controllerType: 16, localPosition: Object.freeze([0, 0, 0]), radius: 0.09 }),
  Object.freeze({ controllerType: 16, localPosition: Object.freeze([0.32, -0.02, 0]), radius: 0.1 }),
  Object.freeze({ controllerType: 20, localPosition: Object.freeze([-0.01, 0, -0.06]), radius: 0.12 }),
  Object.freeze({ controllerType: 20, localPosition: Object.freeze([-0.01, 0, 0.06]), radius: 0.12 }),
  Object.freeze({ controllerType: 20, localPosition: Object.freeze([0.2, -0.02, 0.04]), radius: 0.18 }),
  Object.freeze({ controllerType: 20, localPosition: Object.freeze([0.2, -0.02, -0.04]), radius: 0.18 }),
  Object.freeze({ controllerType: 24, localPosition: Object.freeze([0, 0.01, 0.01]), radius: 0.14 }),
  Object.freeze({ controllerType: 24, localPosition: Object.freeze([0.34, -0.01, 0.02]), radius: 0.13 }),
  Object.freeze({ controllerType: 31, localPosition: Object.freeze([0, 0.01, -0.01]), radius: 0.14 }),
  Object.freeze({ controllerType: 31, localPosition: Object.freeze([0.34, -0.01, -0.02]), radius: 0.13 }),
]);

const NATIVE_SPANS = Object.freeze([
  Object.freeze({ pointIndex: 0, pointCount: 2 }),
  Object.freeze({ pointIndex: 2, pointCount: 2 }),
  Object.freeze({ pointIndex: 4, pointCount: 4 }),
  Object.freeze({ pointIndex: 8, pointCount: 2 }),
  Object.freeze({ pointIndex: 10, pointCount: 2 }),
  Object.freeze({ pointIndex: 12, pointCount: 2 }),
  Object.freeze({ pointIndex: 14, pointCount: 2 }),
  Object.freeze({ pointIndex: 16, pointCount: 2 }),
  Object.freeze({ pointIndex: 18, pointCount: 2 }),
  Object.freeze({ pointIndex: 20, pointCount: 4 }),
  Object.freeze({ pointIndex: 24, pointCount: 2 }),
  Object.freeze({ pointIndex: 26, pointCount: 2 }),
]);

export const NATIVE_SECONDARY_MOTION_MODEL_PROFILES = Object.freeze({
  KOK: Object.freeze({
    retainedDisplacement: 0.599999964,
    downwardStepByMode: Object.freeze({
      0: 0.0249999985,
      1: 0.0249999985,
      2: 0.0349999964,
      3: 0.0299999993,
      default: 0.0249999985,
    }),
  }),
});

export const NATIVE_SECONDARY_MOTION_COLLISION_PROFILES = Object.freeze({
  KOK: Object.freeze({
    sourceAddress: "0x0c297f98",
    sourceSha256: "10117d57163ccbc107ea75133c4f87b3f4e3e28a1a3fcfea450eaa98f77474e9",
    nodeCollision: Object.freeze({
      sourceVectorOffset: "0x20",
      runtimeModeOffset: "0x0e",
      runtimeModeMask: "0x1f",
      sourceSelection: "childSourceOrSelf",
      runtimeModeDerivation: "chainOrdinalLowFiveBits",
      radiusLengthScaleByMode: Object.freeze({
        0: 0.799999952,
        1: 1,
        2: 1.19999993,
        default: 1.5,
      }),
      clearanceByMode: Object.freeze({
        0: 0.0149999997,
        default: 0.00999999978,
      }),
    }),
    points: KOK_POINTS,
    spans: NATIVE_SPANS,
    projection: Object.freeze({
      endpointBias: 0.100000001,
      interiorLow: 0.400000006,
      interiorHigh: 0.600000024,
      segmentLengthSquaredFloor: 1.00000001e-07,
      normalLengthFloor: 9.99999975e-05,
    }),
  }),
});
